import { render, staticRenderFns } from "./Postback.vue?vue&type=template&id=5f1c56ee&"
import script from "./Postback.vue?vue&type=script&lang=js&"
export * from "./Postback.vue?vue&type=script&lang=js&"
import style0 from "./Postback.vue?vue&type=style&index=0&id=5f1c56ee&prod&lang=scss&"
import style1 from "./Postback.vue?vue&type=style&index=1&id=5f1c56ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports